import {InjectionToken, Signal} from '@angular/core';

export interface PaymentSettings {
  isFastCashPaymentEnabled: Signal<boolean>;
}

export const PAYMENT_SETTINGS = new InjectionToken<PaymentSettings>('PAYMENT_SETTINGS');
